import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

export const fieldsMatch = (field1: string, field2: string = null): OLO.Common.IValidators => {
    return (control: AbstractControl): { [key: string]: any } | null => {
        let f1: AbstractControl = (control as FormGroup).controls[field1];
        let f2: AbstractControl = (control as FormGroup).controls[field2];

        return f1.value === f2.value ? null : { 'fieldsMatchError': `Fields don't match` };
    };
};


export const fieldMatchTo = (otherField: string, context?: string, message?: string): OLO.Common.IValidators => {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const foundField: AbstractControl = control.parent ? control.parent.controls[otherField] : null;
        if (!foundField) {

            return null;
        }
        if (!foundField.pristine === false || !foundField.touched || !foundField.dirty || foundField.disabled || !control.value) return null;

        return control.value === foundField.value ? null : {
            'fieldMatchTo': {
                message: message || `Fields don't match`,
                otherFieldValue: foundField.value,
                otherFieldName: otherField,
                context: context || null,
            }
        };
    };
};
